import { getCountryCodeFromToken } from "../guards/common/authentification-functions";
import { CountryCode, countryCurrencies } from "../model/common/country";
import { currencyMap } from "../model/common/money";

export const iso3CountryToCurrencyMap: Record<string, string> = {
  USA: "$",          // United States - USD
  DEU: "€",          // Germany - EUR
  GBR: "£",          // United Kingdom - GBP
  NGA: "₦",          // Nigeria - NGN
  JPN: "¥",          // Japan - JPY
  IND: "₹",          // India - INR
  CHN: "¥",          // China - CNY
  AUS: "A$",         // Australia - AUD
  CAN: "C$",         // Canada - CAD
  ZAF: "R",          // South Africa - ZAR
  ZMB: "ZK",         // Zambia - ZMW (symbol remains ZK)
  // Add more as needed
};

export function getCurrencySymbol(code: string): string {

  return iso3CountryToCurrencyMap[code.toUpperCase()] || code;
}

export function getCurrencySymbolFromCurrency(code: string): string {
  return currencyMap[code.toUpperCase()] || code;
}

export const getCurrencyFromCountryCode = (countryCode: string): string => {
  return currencyMap[countryCurrencies[countryCode as CountryCode]];
};

export const getCurrencyFromToken = (): string => {
  const token = sessionStorage.getItem("token")!;

  const country = getCountryCodeFromToken(token);

  if (!country) {
    return "No currency found";
  }
  console.log(country)
  const currency = currencyMap[countryCurrencies[country as CountryCode]];
  console.log(currency)
  return currency ? currency : "No currency found";
};
